import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Laptop } from 'lucide-react';

/** Slim sticky toolbar at the top of every page: title/breadcrumbs left, actions right. */
const PageHeader = ({ children, actions }) => {
  const { pathname } = useLocation();
  return (
    <header className="sticky top-0 z-20 flex min-h-14 flex-wrap items-center gap-x-4 gap-y-2 border-b border-border bg-background/90 px-4 py-2.5 backdrop-blur supports-[backdrop-filter]:bg-background/75 sm:px-6">
      <div className="flex min-w-0 flex-1 items-center gap-2">{children}</div>
      <div className="flex flex-wrap items-center gap-1.5">
        {actions}
        {/* Rarely needed (install once), so a quiet icon rather than a sidebar entry */}
        {pathname !== '/desktop' && (
          <Link
            to="/desktop"
            title="Desktop app for Mac & Windows"
            aria-label="Desktop app for Mac and Windows"
            className="ml-1 flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Laptop className="h-4 w-4" aria-hidden="true" />
          </Link>
        )}
      </div>
    </header>
  );
};

export const PageTitle = ({ children }) => (
  <h1 className="truncate text-[15px] font-semibold tracking-[-0.01em]">{children}</h1>
);

export default PageHeader;
